import React from 'react';

import { NotificationsButton } from './notifications-button';
import { FormContext } from '../contexts';
import { useFormRefs } from '../hooks';

export function FormErrorsButton(): JSX.Element {
  const { formErrors, defaultFormErrorsExpanded } = React.useContext(FormContext);
  const { focusField } = useFormRefs();

  const totalErrors = React.useMemo(
    () => (formErrors ? Object.keys(formErrors).length : 0),
    [formErrors]
  );

  return (
    <NotificationsButton totalErrors={totalErrors} defaultOpen={defaultFormErrorsExpanded}>
      <NotificationsButton.List
        onClickError={(field): void => {
          focusField(field.inputName);
        }}
        properties={formErrors ?? {}}
      />
    </NotificationsButton>
  );
}
